import React from 'react';
import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import SearchTemplates from './SearchTemplates';
import { getYupSchemaFromMetaData } from '../../../utils/yupSchema/yupSchemaGenerator';

const SearchMyTemplates = (props) => {
  const formField = searchForm;
  const newSearchValidationSchema = getYupSchemaFromMetaData(formField, [], []);

  const initialValues = {
    templateSearchFor: '',
  };

  return (
    <div>
      <Formik initialValues={initialValues} enableReinitialize={true} validationSchema={newSearchValidationSchema}>
        {({ values, setFieldValue, errors, setFieldTouched }) => (
          <Form className="template-Searchbar">
            <SearchTemplates
              formField={formField}
              formikValues={values}
              setFieldTouched={setFieldTouched}
              setFieldValue={setFieldValue}
              onAddressChange={props.onAddressChange}
              errors={errors}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default SearchMyTemplates;

const searchForm = {
  templateSearchFor: {
    props: {
      name: 'templateSearchFor',
      label: 'Search by',
      type: 'text',
      placeholder: 'Template name',
    },
  },
};

SearchMyTemplates.propTypes = {
  onAddressChange: PropTypes.func,
};
